import React, { PropTypes } from 'react';
import throttle from 'jsTools/throttle';

const Scrollsprite = React.createClass({
  displayName: "Scrollsprite",
  propTypes : {
    sprite: PropTypes.string,
    frames: PropTypes.number,
    ratio: PropTypes.number
  },
  getInitialState() {
    return {
      posY: 100
    };
  },
  componentDidMount() {
    this._startScrollListener();
  },
  componentWillUnmount() {
    this._stopScrollListener();
  },
  _startScrollListener() {
    window.addEventListener('scroll', this._handleScrollThrottled());
  },
  _stopScrollListener() {
    window.removeEventListener('scroll', this._handleScrollThrottled());
  },
  _handleScrollThrottled() {
    if (!this.throttledScroll) {
      this.throttledScroll = throttle(this._onScroll, 40).bind(this);
    }
    return this.throttledScroll;
  },
  _onScroll() {
    this._updateSprite();
  },
  _updateSprite() {
    var sprite = this.sprite;
    if (!sprite) {
      return false;
    }
    var dims = sprite.getBoundingClientRect();
    var top = dims.top;
    var height = dims.height;
    var h = window.innerHeight - height;
    if (top > 0 && top < h) {
      var sliceH = h/this.props.frames;
      var onSlice = Math.round(top/sliceH);
      var posPerc = (100/(this.props.frames) * onSlice);
      this.setState({
        posY: posPerc
      });
    } else if (top < 0) {
      this.setState({
        posY: 0
      });
    } else if (top > h) {
      this.setState({
        posY: 100
      });
    }

  },
  render () {
    const {sprite, ratio, ...rest} = this.props;
    const inlineStyles = {
      paddingTop: ratio + '%',
      backgroundPositionY: this.state.posY + '%',
      backgroundImage: 'url("'+ sprite + '")',
      backgroundSize: 'cover'
    };
    return (
      <div {...rest} ref={(node) => {this.sprite = node;}}>
        <div style={inlineStyles}/>
      </div>
    );
  }
});

export default Scrollsprite;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Scrollsprite/Scrollsprite.js
 **/